<app-panel *ngIf="services" [@fadeInOut]>
  <h4 class="header">Get a helping hand</h4>
  <p class="mt-1">
    Make things easy for yourself by letting us install your new product and
    recycle the old one.
  </p>

  <div class="extras">
    <app-add-extra
      [isChecked]="isInstallationSelected"
      [hasHint]="true"
      (checked)="onSelect($event, Description.Installation)"
      *ngIf="installation; else installationUnavailable"
    >
      <ng-container text>
        <p class="margin--none">
          <strong>Add installation</strong>
        </p>
      </ng-container>

      <ng-container value>
        <span
          [class.price-free]="
            !(installation?.charge_customer && installation?.price_gross)
          "
        >
          {{
            installation?.charge_customer && installation?.price_gross
              ? (installation?.price_gross | currency : 'GBP')
              : '£0.00 to pay'
          }}
        </span>
      </ng-container>

      <!-- show when Installation checkbox is selected -->
      <ng-container hintText>
        <p class="margin--none">
          To help us with the installation, your current product needs to be
          disconnected and any contents removed.
          <a
            [href]="links.faq"
            target="_blank"
            class="d-block mt-1 link link--primary"
            >Find out more</a
          >
        </p>
      </ng-container>
    </app-add-extra>

    <ng-template #installationUnavailable>
      <app-add-extra [isDisabled]="true">
        <ng-container disabled-text> Installation not available </ng-container>
        <p>
          We’re unable to offer installation for this product.
          <a
            [href]="links.faq"
            target="_blank"
            class="d-block mt-1 link link--primary"
            >Find out more</a
          >
        </p>
      </app-add-extra>
    </ng-template>

    <app-add-extra
      [isChecked]="isDisposalSelected"
      [hasHint]="true"
      (checked)="onSelect($event, Description.Disposal)"
      *ngIf="disposal; else disposalUnavailable"
    >
      <ng-container text>
        <p class="margin--none">
          <strong>Add recycling</strong>
        </p>
      </ng-container>

      <ng-container value>
        <span
          [class.price-free]="
            !(disposal?.charge_customer && disposal?.price_gross)
          "
        >
          {{
            disposal?.charge_customer && disposal?.price_gross
              ? (disposal?.price_gross | currency : 'GBP')
              : '£0.00 to pay'
          }}
        </span>
      </ng-container>

      <!-- show when Disposal checkbox is selected -->
      <ng-container hintText>
        <p class="margin--none">
          {{
            (isMieleSupplier$ | async)
              ? "We'll take care of disconnecting and recycling your current product — Please make sure any contents are removed beforehand."
              : 'To help us with the recycling, your current product needs to disconnected and any contents removed.'
          }}
          <a
            [href]="links.faq"
            target="_blank"
            class="d-block mt-1 link link--primary"
            >Find out more</a
          >
        </p>
      </ng-container>
    </app-add-extra>
    <ng-template #disposalUnavailable>
      <app-add-extra [isDisabled]="true">
        <ng-container disabled-text> Recycling not available </ng-container>
        <p>
          We’re unable to offer recycling for this product.
          <a
            [href]="links.faq"
            target="_blank"
            class="d-block mt-1 link link--primary"
            >Find out more</a
          >
        </p>
      </app-add-extra>
    </ng-template>
  </div>
  <dgx-components-button
    variant="primary"
    data-automation="productSelectContinue"
    (clicked)="continue.emit(true)"
    >Continue</dgx-components-button
  >
</app-panel>
